export default __webpack_public_path__ + "static/media/polygon.9716d3d1.svg";